var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-page",
    { staticClass: "w-container" },
    [
      !_vm.state.sale.ContactID
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-contact-search", {
                    attrs: {
                      "group-id": _vm.state.getContactGroupID(),
                      fancy: "",
                      label: _vm.$ct("contact-label"),
                      value: _vm.state.sale.Contact,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.state.selectContact($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  !_vm.state.isSubscription()
                    ? _c("app-sale-type-select", {
                        attrs: {
                          value: _vm.state.sale.Type,
                          "ignored-type-ids": _vm.ignoredTypes,
                          "use-object": "",
                          label: _vm.$ct("type-choose"),
                          fancy: "",
                          "contact-group-id": _vm.state.getContactGroupID(),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onTypeChange($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-sell-category-select", {
                    attrs: {
                      label: _vm.$ct("price-category-choose"),
                      fancy: "",
                      "active-only": "",
                    },
                    model: {
                      value: _vm.state.sale.PriceCategory,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.sale, "PriceCategory", $$v)
                      },
                      expression: "state.sale.PriceCategory",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-sale-edit-vat-regime-select", {
                    attrs: {
                      state: _vm.state,
                      label: _vm.$ct("vat-regime"),
                      fancy: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-row",
            [
              _c("app-breadcrumb", {
                style: { width: "100%" },
                attrs: { state: _vm.state },
              }),
              _c("w-spacer"),
              _c(
                "w-col",
                { attrs: { sm: "4", md: "4", lg: "3" } },
                [
                  _c("app-sale-type-select", {
                    attrs: {
                      value: _vm.state.sale.Type,
                      "ignored-type-ids": [10],
                      "use-object": "",
                      label: _vm.$ct("type-choose"),
                      "contact-group-id": _vm.state.getContactGroupID(),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onTypeChange($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "4", md: "4", lg: "3" } },
                [
                  _c("app-sale-edit-vat-regime-select", {
                    attrs: {
                      state: _vm.state,
                      label: _vm.$ct("vat-regime"),
                      fancy: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "4", md: "4", lg: "3" } },
                [
                  _c("app-sell-category-select", {
                    attrs: {
                      label: _vm.$ct("price-category-choose"),
                      fancy: "",
                      "active-only": "",
                    },
                    model: {
                      value: _vm.state.sale.PriceCategory,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.sale, "PriceCategory", $$v)
                      },
                      expression: "state.sale.PriceCategory",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }